const accountServiceMixin = {
    data: function () {
        return {
            ACCOUNT_BASE: '/Api/Account/'
        }
    },
    methods: { 
        registerUserApi: function (data) {
            return this.post(this.ACCOUNT_BASE, 'RegisterUser', data, true);
        },
        registerTradeUserApi: function (data) {
            return this.post(this.ACCOUNT_BASE, 'RegisterTradeUser', data, true);
        },
        loginUser: function (data) {
            return this.post(this.ACCOUNT_BASE, 'LoginUser', data);
        },
        addPassword: function (data) {
            return this.post(this.ACCOUNT_BASE, 'AddPassword', data);
        },
        changePassword: function (data) {
            return this.post(this.ACCOUNT_BASE, 'ChangePassword', data);
        },
        resetPassword: function (data) {
            return this.post(this.ACCOUNT_BASE, 'ResetPassword', data);
        },
        addOrUpdateAddress: function (data) {
            return this.post(this.ACCOUNT_BASE, 'AddOrUpdateAddress', data);
        },
        deleteAddressApi: function (data) {
            return this.post(this.ACCOUNT_BASE, 'DeleteAddress', data);
        },
        forgotPassword: function (data) {
            return this.post(this.ACCOUNT_BASE, 'ForgotPassword', data, true);
        },
        updateDetails: function (data) {
            return this.post(this.ACCOUNT_BASE, 'UpdateDetails', data);
        },
        getAddressesApi : function () {
            return this.get(this.ACCOUNT_BASE, 'GetAddresses');
        },
        getAddressApi: function (data) {
            return this.get(this.ACCOUNT_BASE, 'GetAddress', data);
        }
    }
}